/**
 * Breadcrumb Component
 * Navigation breadcrumb trail for folder hierarchy
 */

import React from 'react';

const Breadcrumb = ({ path = [], onNavigate, rootLabel = 'Home' }) => {
  const handleClick = (folderId, index) => {
    onNavigate(folderId, index === 0 ? rootLabel : path[index - 1]?.name);
  };

  return (
    <nav className="rf-breadcrumb" aria-label="Folder navigation">
      {/* Home/Root */}
      <div className="rf-breadcrumb-item">
        <button
          className={`rf-breadcrumb-link ${path.length === 0 ? 'current' : ''}`}
          onClick={() => handleClick(null, -1)}
          disabled={path.length === 0}
        >
          <i className="fas fa-home"></i>
          <span>{rootLabel}</span>
        </button>
      </div>

      {/* Path segments */}
      {path.map((folder, index) => (
        <div key={folder.id} className="rf-breadcrumb-item">
          <span className="rf-breadcrumb-separator">
            <i className="fas fa-chevron-right"></i>
          </span>
          <button
            className={`rf-breadcrumb-link ${index === path.length - 1 ? 'current' : ''}`}
            onClick={() => handleClick(folder.id, index)}
            disabled={index === path.length - 1}
          >
            <i className="fas fa-folder"></i>
            <span>{folder.name}</span>
          </button>
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumb;
